__webpack_require__.p = "https://stag-assets.kurdshopping.net/";